/**
 * @generated SignedSource<<9a53e96cf8ef6feb15581c5f0f07edbe>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesChannelCheckSellerPlanQuery$variables = Record<PropertyKey, never>;
export type salesChannelCheckSellerPlanQuery$data = {
  readonly checkSellerPlan: {
    readonly canSubscribeToNewPlan: boolean;
    readonly currentProductCount: number;
    readonly isLegacyPlan: boolean;
    readonly isProductLimitReached: boolean;
    readonly isV1Plan: boolean;
    readonly maxProductsGrow: number | null;
    readonly maxProductsScale: number | null;
  };
  readonly hasPodProducts: boolean;
  readonly modelsCount: number;
};
export type salesChannelCheckSellerPlanQuery = {
  response: salesChannelCheckSellerPlanQuery$data;
  variables: salesChannelCheckSellerPlanQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SellerPlanCheck",
    "kind": "LinkedField",
    "name": "checkSellerPlan",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isLegacyPlan",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isV1Plan",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isProductLimitReached",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxProductsGrow",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxProductsScale",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentProductCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canSubscribeToNewPlan",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "environment",
        "value": 2
      }
    ],
    "kind": "ScalarField",
    "name": "modelsCount",
    "storageKey": "modelsCount(environment:2)"
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasPodProducts",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelCheckSellerPlanQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "salesChannelCheckSellerPlanQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "e251d09eaabc780364bea4948e51e63e",
    "id": null,
    "metadata": {},
    "name": "salesChannelCheckSellerPlanQuery",
    "operationKind": "query",
    "text": "query salesChannelCheckSellerPlanQuery {\n  checkSellerPlan {\n    isLegacyPlan\n    isV1Plan\n    isProductLimitReached\n    maxProductsGrow\n    maxProductsScale\n    currentProductCount\n    canSubscribeToNewPlan\n  }\n  modelsCount(environment: 2)\n  hasPodProducts\n}\n"
  }
};
})();

(node as any).hash = "f83a0553fd5e2040d338c2cdcb22a139";

export default node;
